import type { RouteRecordRaw } from 'vue-router';

/**
 * Administration screens (Companies & Sites, Users & Roles) — `screens/03-companies-sites.md` and
 * `screens/04-users-roles.md`. Kept in its own file so parallel screen-building agents can each add
 * one `routes/*.ts` array and spread it into `router.ts` with a single additive line (see AGENTS.md
 * parallel-work rules in the task brief), rather than everyone editing the same route list.
 *
 * These are core-platform (organization/iam) screens, not gated by `requiresModule` the way a
 * business module's screens are — every tenant has companies/sites/users regardless of which
 * business modules it has entitled. Page-level code still checks the specific
 * `organization.*`/`iam.*` permission before rendering data or actions (ForbiddenState otherwise).
 */
export const adminOrgRoutes: RouteRecordRaw[] = [
  {
    path: 'admin/org/companies-sites',
    name: 'admin-org-companies-sites',
    component: () => import('../pages/admin/org/CompaniesSitesPage.vue'),
  },
  {
    path: 'admin/org/users-roles',
    name: 'admin-org-users-roles',
    component: () => import('../pages/admin/org/UsersRolesPage.vue'),
  },
];
